import { createAction } from 'redux-starter-kit';
import api from 'api';
import { errHelper } from 'utils';

export const CREATE_CASE = 'case/create-case';
export const SET_EXECUTIVE_SUMMARY = 'case/executive-summary';
export const SET_CASE_INFO = 'case/set-case-info';
export const SET_LINKED_CUSTOMERS_TO_CASE = 'case/set-linked-customers';
export const SET_IS_LOADING_CASE_INFO = 'case/set-is-loading-case-info';
export const SET_IS_CASE_INFO_LOADED = 'case/set-is-case-info-loaded';
export const CLEAR_CASE = 'case/clear-case';
export const SET_HAS_EXISTING_POLICIES = 'SET/has-existing-policies';
export const SET_NEXT_PAGE = 'case/set-next-page';
export const SET_RISK_SUMMARIES = 'GET/risk-summaries/';
export const FETCH_START = 'case/fetch-data/';
export const FETCH_SUCCESS = 'case/fetch-success/';
export const FETCH_FAILURE = 'case/fetch-failure/';
export const SET_EXISTING_POLICIES = 'GET/existing-policies/';
export const CLEAR_EXISTING_POLICIES = 'RESET/existing-policies';
export const ADD_NEW_EXISTING_POLICY = 'ADD/existing-policy';
export const REMOVE_EXISTING_POLICY = 'REMOVE/existing-policy';
export const MARK_AS_SAVED = 'MARK_AS_SAVED/existing-policy';
export const UPDATE_EXISTING_POLICY = 'UPDATE/existing-policy';
export const SET_EXISTING_ASSET_ALLOCATIONS =
  'charts/SET_EXISTING_ASSET_ALLOCATIONS';
export const SET_ASSET_ALLOCATIONS = 'charts/SET_ASSET_ALLOCATIONS';
export const SET_SECTOR_BREAKDOWN = 'charts/SET_SECTOR_BREAKDOWN';
export const SET_COUNTRY_BREAKDOWN = 'charts/SET_COUNTRY_BREAKDOWN';
export const SET_REGIONAL_BREAKDOWN = 'charts/SET_REGIONAL_BREAKDOWN';
export const SET_EXISTING_SECTOR_BREAKDOWN =
  'charts/SET_EXISTING_SECTOR_BREAKDOWN';
export const SET_EXISTING_COUNTRY_BREAKDOWN =
  'charts/SET_EXISTING_COUNTRY_BREAKDOWN';
export const SET_EXISTING_REGIONAL_BREAKDOWN =
  'charts/SET_EXISTING_REGIONAL_BREAKDOWN';
export const SET_PAST_PERFORMANCE = 'charts/SET_PAST_PERFORMANCE';
export const SET_EXISTING_POLICIES_CHARGES =
  'charts/SET_EXISTING_POLICIES_CHARGES';
export const SET_EXISTING_POLICIES_PERFORMANCE =
  'charts/SET_EXISTING_POLICIES_PERFORMANCE';
export const SET_RECOMMENDED_POLICIES_CHARGES =
  'charts/SET_RECOMMENDED_POLICIES_CHARGES';
export const SET_PORTFOLIO_SPLIT = 'charts/SET_PORTFOLIO_SPLIT';
export const SET_TOTAL_ONGOING_CHARGES = 'charts/TOTAL_ONGOING_CHARGES';
export const SET_TOTAL_PERFORMANCE_DATA = 'charts/SET_TOTAL_PERFORMANCE_DATA';
export const SET_PORTFOLIO_RISK_SCORE = 'charts/PORTFOLIO_RISK_SCORE';
export const SET_EXISITNG_POLICIES_RISK_SCORE =
  'charts/EXISTIN_POLICIES_RISK_SCORE';
export const SET_RECOMMENDED_POLICIES_RISK_SCORE =
  'charts/SET_RECOMMENDED_POLICIES_RISK_SCORE';
export const SET_PAST_PERFORMANCE_AGGREGAGES =
  'charts/PAST_PERFORMANCE_AGGREGATES';
export const SET_AGGREGATE_COST_AND_CHARGES =
  'charts/AGGREGATE_COST_AND_CHARGES';
export const SET_AGGREGATE_COST_AND_CHARGES_TABLE =
  'charts/AGGREGATE_COST_AND_CHARGES_TABLE';
export const SET_ALL_AGGREGATE_COST_AND_CHARGES =
  'charts/ALL_AGGREGATE_COST_AND_CHARGES';
export const SET_WITHDRAWALS = 'SET/withdrawals/';
export const SET_POLICIES = 'GET/policies/';
export const UPDATE_POLICIE = 'UPDATE/policie/';
export const SET_CONTRIBUTIONS = 'SET/contributions/';
export const SET_CONTRIBUTIONS_SUMMARY = 'SET/contributions/summary';
export const SET_HOLDINGS = 'set/holdings';
export const SET_PROVIDERS = 'company/SET_PROVIDERS';
export const SET_APPLIED_ADVISOR_CHARGES = 'SET/advisor-charges/applied';

const createCase = createAction(CREATE_CASE);
const setExecutiveSummary = createAction(SET_EXECUTIVE_SUMMARY);
const setCaseInfo = createAction(SET_CASE_INFO);
const setLinkedCustomersToCase = createAction(SET_LINKED_CUSTOMERS_TO_CASE);
const setIsLoadingCaseInfo = createAction(SET_IS_LOADING_CASE_INFO);
const setIsCaseInfoLoaded = createAction(SET_IS_CASE_INFO_LOADED);
const clearCase = createAction(CLEAR_CASE);
export const setHasExistingPolicies = createAction(SET_HAS_EXISTING_POLICIES);
const setNextPage = createAction(SET_NEXT_PAGE);
export const setRiskSummaries = createAction(SET_RISK_SUMMARIES);
export const fetchStart = createAction(FETCH_START);
export const fetchSuccess = createAction(FETCH_SUCCESS);
export const fetchFailure = createAction(FETCH_FAILURE);
export const setExistingPolicies = createAction(SET_EXISTING_POLICIES);
export const clearExistingPolicies = createAction(CLEAR_EXISTING_POLICIES);
export const addNewExistingPolicy = createAction(ADD_NEW_EXISTING_POLICY);
export const removeExistingPolicy = createAction(REMOVE_EXISTING_POLICY);
export const markAsSaved = createAction(MARK_AS_SAVED);
export const updateExistingPolicy = createAction(UPDATE_EXISTING_POLICY);
export const setAssetAllocations = createAction(SET_ASSET_ALLOCATIONS);
export const setExistingAssetAllocations = createAction(
  SET_EXISTING_ASSET_ALLOCATIONS
);
export const setSectorBreakdown = createAction(SET_SECTOR_BREAKDOWN);
export const setCountryBreakdown = createAction(SET_COUNTRY_BREAKDOWN);
export const setRegionalBreakdown = createAction(SET_REGIONAL_BREAKDOWN);
export const setExistingSectorBreakdown = createAction(
  SET_EXISTING_SECTOR_BREAKDOWN
);
export const setExistingCountryBreakdown = createAction(
  SET_EXISTING_COUNTRY_BREAKDOWN
);
export const setExistingRegionalBreakdown = createAction(
  SET_EXISTING_REGIONAL_BREAKDOWN
);
export const setPastPerformance = createAction(SET_PAST_PERFORMANCE);
export const setExistingPoliciesCharges = createAction(
  SET_EXISTING_POLICIES_CHARGES
);
export const setExistingPoliciesPerformance = createAction(
  SET_EXISTING_POLICIES_PERFORMANCE
);
export const setRecommendedPoliciesCharges = createAction(
  SET_RECOMMENDED_POLICIES_CHARGES
);
export const SET_AGGREGATE_DATA_FOR_POLICIES =
  'charts/AGGREGATE_DATA_FOR_POLICIES';
export const SET_ASSET_ALLOCATION_EVALUE = 'charts/SET_ASSET_ALLOCATION_EVALUE';
export const INVALIDATE_STORE_SUBSET = 'case/INVALIDATE_STORE_SUBSET';

export const setPortfolioSplit = createAction(SET_PORTFOLIO_SPLIT);
export const setTotalOngoingCharges = createAction(SET_TOTAL_ONGOING_CHARGES);
export const setTotalPerformanceData = createAction(SET_TOTAL_PERFORMANCE_DATA);
export const setPortfolioRiskScore = createAction(SET_PORTFOLIO_RISK_SCORE);
export const setExistingPoliciesRiskScore = createAction(
  SET_EXISITNG_POLICIES_RISK_SCORE
);
export const setRecommendedPoliciesRiskScore = createAction(
  SET_RECOMMENDED_POLICIES_RISK_SCORE
);
export const setPastPerformanceAggregates = createAction(
  SET_PAST_PERFORMANCE_AGGREGAGES
);
export const setAllAggregateCostAndCharges = createAction(
  SET_ALL_AGGREGATE_COST_AND_CHARGES
);
export const setAggregateCostAndCharges = createAction(
  SET_AGGREGATE_COST_AND_CHARGES
);
export const setAggregateDataForPolicies = createAction(
  SET_AGGREGATE_DATA_FOR_POLICIES
);
export const setAssetAllocationEvalue = createAction(
  SET_ASSET_ALLOCATION_EVALUE
);
export const setAggregateCostAndChargesTable = createAction(
  SET_AGGREGATE_COST_AND_CHARGES_TABLE
);
export const invalidateStoreSubset = createAction(INVALIDATE_STORE_SUBSET);
export const setWithdrawals = createAction(SET_WITHDRAWALS);
export const setPolicies = createAction(SET_POLICIES);
export const updatePolicies = createAction(UPDATE_POLICIE);
export const setContributions = createAction(SET_CONTRIBUTIONS);
export const setContributionsSummary = createAction(SET_CONTRIBUTIONS_SUMMARY);
export const setProviders = createAction(SET_PROVIDERS);
export const setHoldings = createAction(SET_HOLDINGS);
export const setAppliedAdvisorCharges = createAction(
  SET_APPLIED_ADVISOR_CHARGES
);
export const SET_EXISTING_RISK_ANALYSIS = 'charts/SET_EXISTING_RISK_ANALYSIS';
export const setExistingRiskAnalysis = createAction(SET_EXISTING_RISK_ANALYSIS);
export const SET_RECOMMENDED_RISK_ANALYSIS =
  'charts/SET_RECOMMENDED_RISK_ANALYSIS';
export const setRecommendedRiskAnalysis = createAction(
  SET_RECOMMENDED_RISK_ANALYSIS
);

export const caseActions = {
  createCase,
  setCaseInfo,
  setExecutiveSummary,
  clearCase,
  setIsCaseInfoLoaded,
  setLinkedCustomersToCase,
  setNextPage,
  setRiskSummaries,
  fetchStart,
  fetchSuccess,
  fetchFailure,
  setExistingPolicies,
  clearExistingPolicies,
  addNewExistingPolicy,
  removeExistingPolicy,
  markAsSaved,
  updateExistingPolicy,
  setAssetAllocations,
  setExistingAssetAllocations,
  setSectorBreakdown,
  setCountryBreakdown,
  setRegionalBreakdown,
  setExistingSectorBreakdown,
  setExistingCountryBreakdown,
  setExistingRegionalBreakdown,
  setPastPerformance,
  setExistingPoliciesCharges,
  setRecommendedPoliciesCharges,
  setPortfolioSplit,
  setTotalOngoingCharges,
  setPortfolioRiskScore,
  setExistingPoliciesRiskScore,
  setRecommendedPoliciesRiskScore,
  setPastPerformanceAggregates,
  setAggregateCostAndCharges,
  setAggregateDataForPolicies,
  setAssetAllocationEvalue,
  setAggregateCostAndChargesTable,
  invalidateStoreSubset,
  setWithdrawals,
  setPolicies,
  updatePolicies,
  setContributions,
  setContributionsSummary,
  setProviders,
  setHoldings,
  setAppliedAdvisorCharges,
  setExistingPoliciesPerformance,
  setTotalPerformanceData,
  setExistingRiskAnalysis,
  setRecommendedRiskAnalysis,
  refreshPolicyData:
    ({ portfolio, policyId }: { portfolio: string; policyId: number }) =>
    (dispatch: any) => {
      return Promise.all([
        api.getPolicy({
          portfolio: portfolio,
          policyId: policyId
        }),
        api.getAggregateCostAndCharges({
          portfolio: portfolio,
          policyId: policyId
        })
      ]).then(([policy, aggregateCostAndCharges]) => {
        dispatch(updatePolicies(policy.data));
        dispatch(
          setAggregateCostAndCharges({
            data: aggregateCostAndCharges.data.chart,
            id: policy.data.id
          })
        );
        dispatch(
          setAggregateCostAndChargesTable({
            data: aggregateCostAndCharges.data.table,
            id: policy.data.id
          })
        );
      });
    },
  getFullCaseInfo:
    ({ portfolio }: { portfolio: any }) =>
    (dispatch: any) => {
      dispatch(clearCase());
      dispatch(setIsLoadingCaseInfo(true));

      Promise.all([
        api.getCaseInfo({ portfolio }),
        api.getLinkedCustomersToCase({ portfolio })
      ])
        .then(([caseInfo, linkedCustomers]) => {
          dispatch(setCaseInfo(caseInfo));
          dispatch(setLinkedCustomersToCase(linkedCustomers));
          dispatch(setIsCaseInfoLoaded(true));
          dispatch(setIsLoadingCaseInfo(false));
        })
        .catch((err: any) => errHelper(err));
    }
};
